import { render, staticRenderFns } from "./BlankPage.vue?vue&type=template&id=35e040fc"
import script from "./BlankPage.vue?vue&type=script&lang=js"
export * from "./BlankPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports